import { render, staticRenderFns } from "./SpaceManagerValidationModal.vue?vue&type=template&id=487404c2&scoped=true"
import script from "./SpaceManagerValidationModal.vue?vue&type=script&lang=js"
export * from "./SpaceManagerValidationModal.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagerValidationModal.vue?vue&type=style&index=0&id=487404c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487404c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
